import { IConfig } from "./Render";
export const Table = ({className, id, children}:IConfig)=>
{
    return (
        <table id={id} className={className}>{children}</table>
    );
}